import React, { useState } from 'react'
import { SelectButtons } from '../../../../components'

// Lets the user choose who a "Skicka inbjudan" click actually targets — every
// guest with an email ("Alla") or just the currently checked rows ("Valda") —
// before the parent's onSubmit(target) does the actual send. Same
// dialogRef/hideModalDialog/setLoadingModalDialog contract as GuestEditForm/
// GuestAddForm.
export const SendInvitesForm = ({ allCount, selectedCount, onSubmit, dialogRef, hideModalDialog, setLoadingModalDialog }) => {
  const [target, setTarget] = useState(selectedCount > 0 ? 'selected' : 'all')
  const [error, setError] = useState(null)

  const submit = () => {
    setError(null)

    const count = target === 'all' ? allCount : selectedCount
    if (!count) {
      setError('Inga gäster att skicka till')
      return Promise.resolve()
    }

    setLoadingModalDialog(true)
    return onSubmit(target)
      .then(() => {
        setLoadingModalDialog(false)
        hideModalDialog()
      })
      .catch(err => {
        setLoadingModalDialog(false)
        setError(err.message || 'Kunde inte skicka inbjudan')
      })
  }

  if (dialogRef) dialogRef.current = { submit }

  return (
    <div className="form">
      {error && <div className="form-error">{error}</div>}

      <p className="form-hint">Välj vilka gäster som ska få inbjudan.</p>

      <div className="form-block vertical">
        <SelectButtons
          name="send_target"
          value={target}
          options={[
            { value: 'all', label: `Alla (${allCount})` },
            { value: 'selected', label: `Valda (${selectedCount})`, disabled: selectedCount === 0 },
          ]}
          onChange={({ value }) => setTarget(value)}
        />
      </div>
    </div>
  )
}
